<template>
  <base-popup
      :popup-model="show"
      :title="formTitle"
      :valid="!valid"
      :width="45"
      @onCancelButtonClick="closePopupHandler"
      @onSaveButtonClick="saveResellerHandler"
  >
    <v-form
        :ref="formRef"
        v-model="valid"
        lazy-validation
    >
      <v-container class="mt-5">
        <v-row>
          <v-col class="pb-0">
            <v-autocomplete
                ref="autocomplete"
                v-model="currentItem.sites"
                :items="searchResult"
                :rules="requiredFieldRule"
                no-data-text="No result found"
                :search-input.sync="search"
                prepend-icon="mdi-web"
                chips
                color="blue-grey lighten-2"
                label="Select Sites"
                item-text="siteUrl"
                item-value="siteUrl"
                multiple
            >
              <template v-slot:selection="data">
                <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(data.item)"
                >
                  {{ data.item.siteUrl }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.siteUrl"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
            <v-text-field
                v-model="link"
                label="Live Link"
                prepend-icon="mdi-link"
                required
                ref="link"
            >
              <template v-slot:append>
                <v-btn
                    depressed
                    tile
                    color="primary"
                    class="ma-0"
                    @click.prevent.stop="linkHandler">
                  ADD
                </v-btn>
              </template>
            </v-text-field>
            <v-data-table
                v-if="liveLinks.length > 0"
                :headers="headers"
                :items="liveLinks"
                :items-per-page="5"
                hide-default-footer
                class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Live Link List</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon color="red" link @click.prevent.stop="removeLink(item)">mdi-delete</v-icon>
              </template>
            </v-data-table>
            <v-text-field
                class="mt-2"
                v-model="currentItem.email"
                :rules="emailRules"
                label="Email"
                prepend-icon="mdi-email"
                required
            />
            <v-text-field
                v-model.number="currentItem.price"
                :rules="numberRule"
                class="right-align-text"
                label="Price"
                onclick="this.select()"
                prepend-icon="attach_money"
                required
                type="number"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <mail-template-popup
        :show="showMailTemplate"
        :item="currentItem"
        @closeMailPopupHandler="closeMailPopupHandler"
    />
  </base-popup>

</template>
<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import Api from "../../services/Api";
import MailTemplatePopup from "./MailTemplatePopup";

export default {
  name: 'ResellerPaymentPopup',
  components: {MailTemplatePopup, BasePopup},
  mixins: [PopupMixin],
  data() {
    return {
      isLastPage: false,
      noResultText: 'No result found',
      searchItemLimit: 100,
      searchResult: [],
      isLoading: false,
      term$: new Subject(),
      model: null,
      search: null,
      currentPage: 0,
      link: '',
      showMailTemplate: false,
      headers: [
        {
          text: 'Link',
          align: 'start',
          sortable: false,
          value: 'link',
        },
        {
          text: 'Action',
          align: 'end',
          sortable: false,
          value: 'action'
        }
      ],
      liveLinks: []
    }
  },
  watch: {
    search(text) {
      this.term$.next(text);
    }
  },
  mounted() {
    this
        .term$
        .pipe(
            filter(term => term && term.length > 2),
            debounceTime(500),
            distinctUntilChanged()
        )
        .subscribe(term => this.apiSearch(term));
    this.apiSearch('');
  },
  computed: {
    formTitle() {
      if (this.isEditMode) {
        let sites = this.currentItem.name ? this.currentItem.name.split(',') : [];
        this.currentItem.sites = [...sites];

        const links = this.currentItem.link ? this.currentItem.link.split('@') : [];

        this.liveLinks = links.map((item) => {
          return {link: item}
        });

        return 'Edit Generated Reseller Payment Link';
      }
      return 'Generate Reseller Payment Link';
    }
  },
  methods: {
    remove(item) {
      const index = this.currentItem.sites.indexOf(item.siteUrl);
      if (index >= 0) this.currentItem.sites.splice(index, 1)
    },
    visibilityChanged(e) {
      e && this.apiSearch(this.search || '', true);
    },
    apiSearch(term = '', newPage = false) {
      const autoComplete = this.$refs.autocomplete;

      if ((autoComplete && autoComplete.selectedItems.length && !term) ||
          (this.search === term && this.search === '' && term === '') &&
          !newPage
      ) {
        return;
      }
      this.search = term;

      this.isLoading = true;
      if (newPage) {
        ++this.currentPage;
      } else {
        this.searchResult = [];
        this.currentPage = 1;
      }
      const path = `/sites?rowsPerPage=50&descending=false&page=${this.currentPage}&sortBy=site_url&status=true&query=${term || ''}`;
      Api.getRequest({endpoint: path})
          .then((response) => {
            if (!response || !response.data || !response.data.data) {
              return;
            }
            this.searchResult = this.searchResult.concat(response.data.data);
            this.isLastPage = this.searchResult.length === response.data.total;
            setTimeout(() => {
              if (this.$refs && this.$refs.autocomplete && this.$refs.autocomplete.getContent()) {
                this.$refs.autocomplete.onScroll();
              }
            }, 500);
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false));
    },
    onInputClick() {
      this.apiSearch('');
    },
    saveResellerHandler() {
      if (!this.isFormValid) {
        return;
      }

      this.currentItem.name = this.currentItem.sites.toString();
      let links = this.liveLinks.map((item) => item.link);
      this.currentItem.link = links.join('@');
      this.showMailTemplate = true;

      this.$emit('saveItemHandler', {...this.currentItem});
      this.closePopupHandler();
    },
    linkHandler() {
      if (this.link) {
        this.liveLinks.push({link: this.link})
      }
      this.link = '';
    },
    removeLink(item) {
      const index = this.liveLinks.indexOf(item);

      if (index !== -1) {
        this.liveLinks.splice(index, 1);
      }
    },
    closeMailPopupHandler() {
      this.showMailTemplate = false;
    }
  }
}
</script>
